(() => {
  const STORAGE_KEY = 'ormsbyCollectionHideSoldOut';
  const ROOT_CLASS = 'collection-hide-sold-out';
  const PARAM = 'filter.v.availability';

  const isClientMode = () =>
    Boolean(document.querySelector('[data-stock-filter-mode="client"] [data-collection-stock-filter]'));

  const readPreference = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(PARAM) === '1') return true;
    if (params.get(PARAM) === '0') return false;

    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored === '0') return false;
    if (stored === '1') return true;

    return true;
  };

  const syncUrl = (hideSoldOut) => {
    const url = new URL(window.location.href);
    if (hideSoldOut) {
      url.searchParams.set(PARAM, '1');
    } else {
      url.searchParams.delete(PARAM);
    }
    window.history.replaceState({}, '', url);
  };

  const updateCounts = () => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    const visibleCount = items.filter((item) => !item.hasAttribute('hidden')).length;
    const label = visibleCount === 1 ? 'product' : 'products';
    const text = `${visibleCount} ${label}`.toUpperCase();

    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((node) => {
      if (!node) return;
      const target = node.querySelector('span') || node;
      if (target && /product/i.test(target.textContent || '')) {
        target.textContent = text;
      }
    });
  };

  const apply = (hideSoldOut, { persist = true, updateHistory = true } = {}) => {
    document.documentElement.classList.toggle(ROOT_CLASS, hideSoldOut);

    document.querySelectorAll('#product-grid > .grid__item').forEach((item) => {
      const soldOut = item.querySelector('.product-card-wrapper.is-sold-out');
      if (hideSoldOut && soldOut) {
        item.setAttribute('hidden', '');
      } else {
        item.removeAttribute('hidden');
      }
    });

    document.querySelectorAll('[data-stock-filter-mode="client"] [data-collection-stock-filter]').forEach((input) => {
      input.checked = hideSoldOut;
    });

    if (persist) {
      window.sessionStorage.setItem(STORAGE_KEY, hideSoldOut ? '1' : '0');
    }
    if (updateHistory) {
      syncUrl(hideSoldOut);
    }

    updateCounts();
  };

  const onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-collection-stock-filter]')) return;
    if (input.disabled) return;
    apply(input.checked);
  };

  const observeGrid = () => {
    const container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.stockFilterObserved === 'true') return;
    container.dataset.stockFilterObserved = 'true';

    const observer = new MutationObserver(() => {
      if (!isClientMode()) return;
      apply(readPreference(), { persist: false, updateHistory: false });
    });
    observer.observe(container, { childList: true });
  };

  const init = () => {
    if (!isClientMode()) return;
    apply(readPreference(), { persist: true, updateHistory: true });
    document.addEventListener('change', onChange);
    observeGrid();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
